import { ROLES } from '@/constants/roles';

export const documents = {
  path: '/documents',
  component: () => import('./views/Documents/index.vue'),
  meta: {
    title: 'Документы',
    icon: 'mdi-file-multiple-outline',
    accessList: [ROLES.operator],
    instruction: {
      id: 35,
      name: 'Документы',
    },
  },
};

export default [documents];
